window.uncheckCreateNewProduct = function() {
    var status = $('select[name="status"]').val();

    $('input[name="create_new_product"]').prop('disabled', false);
    if (status === 'analysis') {
        $('input[name="create_new_product"]').prop('checked', false);
        $('input[name="create_new_product"]').prop('disabled', true);
    }
};

window.feedTypeShowHide = function(value) {
    $('[data-feed-type-content]').hide();
    $('[data-feed-type-content="' + value + '"]').show();
};

window.getRandom = function(arr) {
    return arr[Math.floor(Math.random()*arr.length)];
};

window.renderSubElement = function($select) {
    let checked = $select.is(':checked');
    let value = $select.val();
    let $row = $select.closest('[data-rule-import-row]');

    if(checked) {
        $row.find('[data-rule-import-content="' + value + '"]').show();
    } else {
        $row.find('[data-rule-import-content="' + value + '"]').hide();
    }
};

window.handleImportConnectionEditStep = function() {
    // zobrazeni formuláře na základě zvolených dat
    $('select[name="status"], input[name="create_new_product"]').on('change', uncheckCreateNewProduct);
    uncheckCreateNewProduct();

    $('[data-feed-type-select]').on('change', function() {
        feedTypeShowHide($(this).val());
    });
    feedTypeShowHide($('[data-feed-type-select]').val());
};

window.handleImportExportConnectionEditStep = function() {
    $('[data-rule-import-select]').on('change', function() {
        renderSubElement($(this));
    });

    $('[data-rule-import-select]').each(function(i, el) {
        renderSubElement($(el));
    });
};

$(document).ready(function() {
    if ($('body').data('router-name') !== 'connection-import-connection-edit') {
        return;
    }

    handleImportConnectionEditStep();
});

$(document).ready(function() {
    if ($('body').data('router-name') !== 'connection-import-connection-setting-edit' && $('body').data('router-name') !== 'connection-export-connection-setting-edit') {
        return;
    }

    handleImportExportConnectionEditStep();
});

$(document).ready(function() {
    if (typeof Livewire == 'undefined') {
        return;
    }
    if ($('body').data('router-name') !== 'connection-import-connection-wizard' && $('body').data('router-name') !== 'connection-export-connection-wizard') {
        return;
    }
    handleImportConnectionEditStep();
    handleImportExportConnectionEditStep();
    Livewire.hook('message.processed', (message, component) => {
        handleImportConnectionEditStep();
        handleImportExportConnectionEditStep();
    });
});
